import { atom } from 'recoil';
import { ReportData } from '../interfaces/Models';

export const tableAtom = atom({
  key: 'tableSession',
  default: {} as ReportData,
});
